import { $t } from '@teachino/shared-i18n';
import { useToast } from './Toast/useToast';

export function useClipboard() {
  const toast = useToast();

  function copy(message: string, showToast?: boolean): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      navigator.clipboard
        .writeText(message)
        .then(() => {
          if (showToast === undefined || showToast) {
            toast.success($t('generic_text_copied_to_clipboard'));
          }
          resolve();
        })
        .catch((e: unknown) => reject(e));
    });
  }
  return { copy };
}
